import { ScheduleBuildEconomicsSettingBase } from './base/schedule-build-economics-setting-base';

export class ScheduleBuildEconomicsSetting extends ScheduleBuildEconomicsSettingBase { }